import { isEmpty } from 'lodash';
import { z } from 'zod';
import { idSchema } from '../validation';

const urlSchema = z.string().url().trim();

const imgIdSchema = idSchema.min(3);
const base64Schema = z
  .string()
  .base64()
  .trim()
  .transform(value => {
    if (value.includes('data:image/jpeg;base64') === false) {
      return `data:image/jpeg;base64,${value}`;
    }
    return value;
  });

const uploadSchema = z
  .string()
  .min(1)
  .transform((arg, ctx) => {
    const url = urlSchema.safeParse(arg);
    const base64 = base64Schema.safeParse(arg);
    if (url.success) return url.data;
    if (base64.success) return base64.data;
    ctx.addIssue({
      code: 'custom',
      message: 'image_not_valid',
    });
    return z.NEVER;
  });
export const imageSchema = z.object({
  /** image url */

  url: urlSchema,

  /** image id */
  id: imgIdSchema,
});
export type Image = z.infer<typeof imageSchema>;

export const imageWithUploadSchema = imageSchema
  .partial({ url: true, id: true })
  .extend({
    /** the `new` or `updated` image you want to upload.
     *
     * the string can be a base64 or url link.
     */
    upload: uploadSchema.optional(),
  })
  .transform((value, ctx) => {
    const isEmptyObj = isEmpty(value);
    if (isEmptyObj) {
      ctx.addIssue({
        code: 'custom',
        message: 'image_no_value_provided',
      });
    }

    if (value.id || value.url) {
      // make sure both url & id exists
      const result = imageSchema.safeParse({ url: value.url, id: value.id });

      if (!result.success) {
        result.error.issues.map(issue => {
          ctx.addIssue(issue);
        });
      }
    }

    return value;
  });

export type ImageWithUpload = z.infer<typeof imageWithUploadSchema>;

export const imageGoogleMapSchema = imageSchema.pick({ url: true });
export type ImageGoogleMap = z.infer<typeof imageGoogleMapSchema>;
